import { ExpandNavV2Service } from "@gtmhub/navigation/expand-nav-v2.service";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";

export const ExpandNavV2ServiceProvider = {
  provide: ExpandNavV2Service,
  useFactory: providerUpgradeFactory("ExpandNavV2Service"),
  deps: ["$injector"],
};

export const NavigationItemsFacadeProvider = {
  provide: NavigationItemsFacade,
  useFactory: providerUpgradeFactory("NavigationItemsFacade"),
  deps: ["$injector"],
};
